import React from 'react';
import { PropInfo, CodeExample, AlertProps } from '@cimpress/react-components';
import AlertCode from '!raw-loader!./alert.jsx';
import AlertDemo from './alert.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const AlertDocs = () => {
  const propInfos: PropInfo<AlertProps>[] = [
    {
      name: 'status',
      type: 'string',
      default: 'danger',
      description: (
        <span>
          One of <code>danger</code>, <code>warning</code>, <code>info</code>, or <code>success</code>, defines the
          alert style.
        </span>
      ),
    },
    {
      name: 'dismissible',
      type: 'boolean',
      default: 'true',
      description: 'Controls whether or not the close button on the right is shown',
    },
    {
      name: 'dismissed',
      type: 'boolean',
      default: 'false',
      description: 'Controls whether or not the alert is dismissed',
    },
    {
      name: 'title',
      type: 'node',
      default: '',
      description: 'Title for the alert. If no title is provided, the alert will not render a title section.',
    },
    {
      name: 'message',
      type: 'node (required)',
      default: '',
      description: 'Message for the alert.',
    },
    {
      name: 'onDismiss',
      type: 'function',
      default: '',
      description: 'A function to be called when the alert is closed.',
    },
  ];

  return (
    <ComponentDoc<AlertProps> name="Alert" propInfos={propInfos}>
      <AlertDemo />
      <CodeExample code={AlertCode} />
    </ComponentDoc>
  );
};

export default AlertDocs;
